var exports = {
  "A": "xa15a2ab7--19ea10--item",
};

module.exports = exports;
